export default "__VITE_ASSET__C$GIRMzu__"